import { useEffect } from "react";
import { AppModal } from "../../../../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { FormGrid, FieldInput, FieldTextarea, FieldColor, FieldSwitch, useForm } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";
import { useApiActionMutation } from "../../../../../_CORE/APP/Hooks/Hooks/_Actions/_useApiActionMutation";
import { NOTEBOOK_COLLECTION_CONSTANTS } from "../_MODULES/_API";
import { isDuplicateRecord } from "../../../../_UI/recordUniqueness";

const EMPTY = { name: "", description: "", color: "#777777", isFavorite: false };

export const NotebookCollectionModal = ({ isOpen, collection = null, collections = [], onClose, onSaved }) => {
    const editing = !!collection?.id;
    const { actionMutate, useActionApiIsLoading } = useApiActionMutation({ isToastError: true, isToastSuccess: true, minTimeMutate: 200 });
    const FORM = useForm({
        initialValues: EMPTY,
        schema: {},
        onSubmit: async (values) => {
            if (!String(values.name || "").trim()) {
                FORM.setError("name", "Escribí un nombre", { focus: true }); return;
            }
            if (isDuplicateRecord({ rows: collections, value: values.name, currentId: collection?.id })) {
                FORM.setError("name", "Ya existe una colección con ese nombre", { focus: true }); return;
            }
            const data = { collection: { name: values.name, description: values.description, color: values.color }, isFavorite: !!values.isFavorite };
            const res = editing
                ? await actionMutate({ method: "PATCH", endpoint: NOTEBOOK_COLLECTION_CONSTANTS.UPDATE, id: collection.id, data, successMessage: "Colección actualizada" })
                : await actionMutate({ method: "POST", endpoint: NOTEBOOK_COLLECTION_CONSTANTS.CREATE, data, successMessage: "Colección creada" });
            if (!res.success) { FORM.applyApiError(res); return; }
            onSaved?.(res.data, editing); onClose?.();
        },
    });

    useEffect(() => {
        if (!isOpen) return;
        FORM.reset(editing ? { ...EMPTY, ...collection, isFavorite: !!collection.isFavorite } : EMPTY);
    }, [isOpen, collection]); // eslint-disable-line react-hooks/exhaustive-deps

    return <AppModal isOpen={isOpen} onClose={onClose} isDirty={FORM.isDirty} size="md"
        title={editing ? "Editar colección" : "Nueva colección"}
        description="Usá colecciones para separar proyectos, libros, ideas, diarios o cualquier material que quieras organizar."
        footer={<><AppButton variant="ghost" tone="neutral" onClick={onClose}>Cancelar</AppButton><AppButton onClick={FORM.onSubmit} isLoading={useActionApiIsLoading}>{editing ? "Guardar cambios" : "Crear colección"}</AppButton></>}>
        <FormGrid columns={2}>
            <FieldInput {...FORM.field("name")} label="Nombre" placeholder="Ej: Proyecto Aurora · Colección 1" span={2} />
            <FieldColor {...FORM.field("color")} label="Color" />
            <FieldSwitch id="notebook_collection_favorite" label="Destacada" text="Mostrar primero" isChecked={!!FORM.values.isFavorite} onChange={(e) => FORM.setValue("isFavorite", e.target.checked)} />
            <FieldTextarea {...FORM.field("description")} label="Descripción" rows={4} span={2} />
        </FormGrid>
    </AppModal>;
};
